import type { ListProps } from '@mui/material/List';
import List from '@mui/material/List';

function SidebarGroup(props: ListProps) {
  return <List {...props} />;
}

SidebarGroup.displayName = 'SidebarGroup';
export default SidebarGroup;
